import React, { useCallback, useEffect, useState } from 'react'
import { Container, BoxChooses, CanvasContainer } from './styles'
import { BoxContainer, Typography } from '../../../../../../../components'
import ecbrApi from '../../../../../../../services/ecbrApi'
import useUrlParam from '../../../../../../../hooks/useUrlParam'
import { renderTextInCanvas } from '../../../../../../../utils/renderTextInCanvas'
import { ECBR_DNA_API } from '../../../../../../../envConfig'
import { getDate } from '../../../../../../../utils/dateUtils'
import { CertificateStatus } from '../../../../../../../constants/certificate'

const Files = () => {
  const [_brandId, certificateId] = useUrlParam(
    '/user/brands/:id/certificates/:id'
  )
  const [error, setError] = useState(null)

  const requestData = useCallback(async () => {
    setError(null)
    try {
      const { data: cert } = await ecbrApi.certificates.getById(certificateId)

      const certStatus = cert.status
      if (certStatus !== CertificateStatus.ACTIVE) {
        setError('O certificado ainda não foi emitido')
        return
      }

      const { data: product } = await ecbrApi.products.getById(cert.productId)

      const brandName = cert.brand?.brandName
      const certDate = cert.updatedAt
      const certHash = cert.hash
      const certName = product.name

      renderTextInCanvas(
        `Certificado ${certName} emitido para: ${brandName} | Data: ${getDate(
          certDate
        )} | Código: ${certHash}`,
        'canvas',
        `${ECBR_DNA_API}/files/${product.imageId}`
      )
    } catch (err) {
      console.log({ err })
      setError('Erro ao gerar o certificado')
    }
  }, [certificateId])

  useEffect(() => {
    requestData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Container>
      <BoxChooses>
        <Typography type="sectionTitle">Download</Typography>
        {/* <Button
          type="button"
          variant="outlined"
          text="Baixar tudo"
          width="150px"
        /> */}
      </BoxChooses>

      <BoxContainer>
        {error && <span>{error}</span>}

        {!error && (
          <CanvasContainer>
            <canvas id="canvas" width="0" height="0"></canvas>
          </CanvasContainer>
        )}
      </BoxContainer>
    </Container>
  )
}

export default Files
